module.exports = __webpack_public_path__ + "img/vyttra_gif_a.d91859c1.gif";